import { Loader, SnackBar, Stripe } from 'ui/services';

export const handleStripe = async (shop, data) => {
  try {
    Loader.show();
    await Stripe.redirectToCheckout(data.key, data.sessionId);
  } catch (e) {
    Loader.hide();
    SnackBar.show('Network connectivity issue. Please check your internet and try again.', 'error');
  }
};
